import React from "react";
import ReactDOM from "react-dom/client";
import "./util.css";
import "./index.css";
import "cropperjs/dist/cropper.css";
import { QueryClient, QueryClientProvider } from 'react-query';
import { HashRouter, Routes, Route } from "react-router-dom";
import { RecoilRoot } from "recoil";
import Global from "./components/Global";
import zhCN from "antd/locale/zh_CN";
import 'dayjs/locale/zh-cn';
import { ConfigProvider } from "antd";
import { loader } from "@monaco-editor/react";

loader.config({
  paths: {
    vs: "https://static.daanjiexi.com/monaco-editor@0.54.0/min/vs",
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      cacheTime: 300000, // 默认缓存 5 分钟（并不代表 5 分钟后才获取数据，是否获取数据由 staleTime 决定）
      // staleTime: 300000, // 数据在 5 分钟内被认为是新鲜的
      refetchOnWindowFocus: false, // 窗口重新获得焦点时不重新获取数据
      refetchOnMount: false, // 组件重新挂载时不重新获取数据
    },
  },
});

import Home from "./pages/Home/Index";
import Login from "./pages/Login/Index";
import NoteFound from "./pages/NotFound/Index";

const BookManagement = React.lazy(() => import("./pages/BookManagement/Index"));
const WordManagement = React.lazy(() => import("./pages/WordManagement/Index"));
const SortManagement = React.lazy(() => import("./pages/SortManagement/Index"));
const ExampleManagement = React.lazy(() => import("./pages/ExampleManagement/Index"));
const NoteManagement = React.lazy(() => import("./pages/NoteManagement/Index"));
const OrderManagement = React.lazy(() => import("./pages/OrderManagement/Index"));
const ProductManagement = React.lazy(() => import("./pages/ProductManagement/Index"));
const UserManagement = React.lazy(() => import("./pages/UserManagement/Index"));
const AnalysisRecord = React.lazy(() => import("./pages/AnalysisRecord/Index"));
const MemoryManagement = React.lazy(() => import("./pages/MemoryManagement/Index"));
const PreorderManagement = React.lazy(() => import("./pages/PreorderManagement/Index"));
const DownloadManagement = React.lazy(() => import("./pages/DownloadManagement/Index"));
const PrintManagement = React.lazy(() => import("./pages/PrintManagement/Index"));
const InvitationRecord = React.lazy(() => import("./pages/InvitationRecord/Index"));
const CommissionRecord = React.lazy(() => import("./pages/CommissionRecord/Index"));
const ArticleManagement = React.lazy(() => import("./pages/ArticleManagement/Index"));

const Page = ({component}: { component: React.ReactNode }) => {
  return (
    <React.Suspense fallback={<></>}>
      {component}
    </React.Suspense>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <QueryClientProvider client={queryClient}>
    <RecoilRoot>
      <HashRouter>
        <ConfigProvider locale={zhCN}>
          <Global>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/bookManagement" element={<Page component={<BookManagement />} />} />
              <Route path="/wordManagement" element={<Page component={<WordManagement />} />} />
              <Route path="/sortManagement" element={<Page component={<SortManagement />} />} />
              <Route path="/exampleManagement" element={<Page component={<ExampleManagement />} />} />
              <Route path="/noteManagement" element={<Page component={<NoteManagement />} />} />
              <Route path="/orderManagement" element={<Page component={<OrderManagement />} />} />
              <Route path="/productManagement" element={<Page component={<ProductManagement />} />} />
              <Route path="/userManagement" element={<Page component={<UserManagement />} />} />
              <Route path="/analysisRecord" element={<Page component={<AnalysisRecord />} />} />
              <Route path="/memoryManagement" element={<Page component={<MemoryManagement />} />} />
              <Route path="/preorderManagement" element={<Page component={<PreorderManagement />} />} />
              <Route path="/downloadManagement" element={<Page component={<DownloadManagement />} />} />
              <Route path="/printManagement" element={<Page component={<PrintManagement />} />} />
              <Route path="/invitationRecord" element={<Page component={<InvitationRecord />} />} />
              <Route path="/commissionRecord" element={<Page component={<CommissionRecord />} />} />
              <Route path="/articleManagement" element={<Page component={<ArticleManagement />} />} />
              <Route path="*" element={<NoteFound />} />
            </Routes>
          </Global>
        </ConfigProvider>
      </HashRouter>
    </RecoilRoot>
  </QueryClientProvider>
)

